import { cx } from "@/utils";
import AccessControl, { ACCESS_LEVELS } from "@components/AccessControl";

import { useEpisode } from "../../context";
import ExternalLink from "../Body/partials/ExternalLink";
import Actions from "../Mention/Actions";
import RemoveMention from "../Mention/RemoveMention";

export type MetaActionsProps = { className?: string };
import styles from "./MetaActions.module.css";

const MetaActions: React.FunctionComponent<MetaActionsProps> = ({
  className,
}) => {
  /**
   * Handle the case where we've got only meta hits
   * but still want to be able to edit the episode using the actions
   */

  const { hideActions, textMentions, audioMentions } = useEpisode();

  if (
    hideActions === true ||
    textMentions.length > 0 ||
    audioMentions.length > 0
  ) {
    return null;
  }

  return (
    <div className={cx(styles.root, className)}>
      <ExternalLink />
      <AccessControl level={ACCESS_LEVELS.USER}>
        <RemoveMention />
      </AccessControl>
      <Actions />
    </div>
  );
};
export default MetaActions;
